import { register } from '../modules/sections.js'
import Section from '../modules/section.js'
import { on } from '../modules/events.js'

class MobileMenuSection extends Section {
  initState() {
    return {
      display: false
    }
  }

  init() {
    this.computed(() => this.displayChanged(this.state.display))
    on('mobilemenu:toggle', () => this.toggle())
    on(this.refs.close, 'pointerup', () => this.toggle())
  }

  toggle() {
    this.state.display = !this.state.display
  }

  displayChanged(value) {
    this.el.dataset.display = value ? 1 : 0
    document.documentElement.classList[value ? 'add' : 'remove']('layout-unscrollable')
  }
}

register('mobilemenu', MobileMenuSection)
